import { CONTROL } from "../../constants/testIds";

// UX-CP-01 §1 "Health/alerts strip". Reuses the same 12-B ops_engine snapshot as
// `/control/ops/health` (gated on the 'ops' Kairoo permission there too — an operator without
// it sees an honest "unavailable" card, never a fabricated green checkmark).
export function PlatformHealthStrip({ health, loading }) {
  if (loading) {
    return <div className="glass-surface rounded-[14px] p-4 h-16 animate-pulse" data-testid={CONTROL.healthStrip} />;
  }
  if (!health?.available) {
    return (
      <div className="glass-surface rounded-[14px] p-4 text-sm" data-testid={CONTROL.healthStrip} style={{ color: "var(--scarlet-text-secondary)" }}>
        Platform health — {health?.reason || "unavailable"}
      </div>
    );
  }
  const errRate = (health.error_rate_overall * 100).toFixed(1);
  const isHealthy = health.error_rate_overall < 0.05;
  return (
    <div className="glass-surface rounded-[14px] p-4 flex items-center gap-6 flex-wrap" data-testid={CONTROL.healthStrip}>
      <div className="flex items-center gap-2">
        <span className="w-2.5 h-2.5 rounded-full" style={{ background: isHealthy ? "var(--status-active-dot)" : "var(--status-overdue-dot)" }} />
        <span className="text-sm font-semibold" style={{ color: "var(--scarlet-text)" }}>{isHealthy ? "All systems normal" : "Elevated error rate"}</span>
      </div>
      <HealthMetric label="Requests" value={health.traffic_total_requests} />
      <HealthMetric label="Error rate" value={`${errRate}%`} />
      <HealthMetric label="In-flight" value={health.saturation_in_flight_requests} />
    </div>
  );
}

function HealthMetric({ label, value }) {
  return (
    <div className="text-sm">
      <span style={{ color: "var(--scarlet-text-secondary)" }}>{label}: </span>
      <span className="font-semibold tabular-nums-force" style={{ color: "var(--scarlet-text)" }}>{value}</span>
    </div>
  );
}
